import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { first } from 'rxjs/operators';
import {Router} from '@angular/router';
import {setCurrentAbeille, setCurrentRole, getUser, getToken} from '../../../assets/utils.js';
import {Sort} from '@angular/material/sort';

import {Aidant, Patient, User} from '../../_models';
import { AidantRelation } from '../../_models';
import { PatientService } from '../../_services';
import { AidantService } from '../../_services';

@Component({
    selector: 'app-dashboard-people-list',
    templateUrl: './dashboard-people-list.component.html',
    styleUrls: ['./dashboard-people-list.component.scss']
})
export class DashboardPeopleListComponent implements OnInit {
    @Input() type: string;
    @ViewChild('search', {static: true}) searchField: ElementRef;
    @ViewChild('actionSelect', {static: false}) actionSelect: ElementRef;

    ready = false;
    user: User;
    token: string;
    patients: Patient[] = [];
    abeilles = [];
    sortedAbeilles = [];
    checkedAbeilles = [];
    currentAbeille = null;

    showModalPatient = false;
    showModalPatientChoice = false;
    showModalEditPatient = false;
    showModalAidant = false;
    showModalShowPatient = false;

    constructor(private router: Router, private patientService: PatientService, private aidantService: AidantService) {

        if (!getUser()) {
            this.router.navigate(['/login']);
        }

        this.user = getUser();
        this.token = getToken();
    }

    ngOnInit() {
        //this.searchField.nativeElement.focus();
        this.refreshList();
    }

    ngAfterViewChecked() {
        setTimeout(() => this.ready = true, 600);
    }

    public refreshList() {

        this.abeilles = [];
        const archived = this.type === 'archives';

        this.patientService.getByUserId(this.user.id, archived).pipe(first()).subscribe(patients => {

            for (let i = 0; i < (patients as Patient[]).length; i++) {
                this.abeilles.push({
                    idAvatar: patients[i].idAvatar,
                    firstName: patients[i].firstName,
                    lastName: patients[i].lastName,
                    role: 'Gérant',
                    data: patients[i],
                });
            }
        });

        this.aidantService.getByUserId(this.user.id).pipe(first()).subscribe(aidants => {

            for (let i = 0; i < (aidants as Aidant[]).length; i++) {
                this.abeilles.push({
                    idAvatar: aidants[i].patient.idAvatar,
                    firstName: aidants[i].patient.firstName,
                    lastName: aidants[i].patient.lastName,
                    role:  'Aidant, ' + aidants[i].role,
                    data: aidants[i].patient
                });
            }

            this.sortedAbeilles = this.abeilles;
        });

        this.showModalPatient = false;
        this.showModalEditPatient = false;
        this.showModalAidant = false;
        this.checkedAbeilles = [];
    }

    searchAbeille() {
        let search = this.searchField.nativeElement.value.toLowerCase();

        this.sortedAbeilles = [];
        this.abeilles.forEach((abeille) => {
            if (abeille.firstName.toLowerCase().indexOf(search) > -1
                || abeille.lastName.toLowerCase().indexOf(search) > -1) {
                this.sortedAbeilles.push(abeille);
            }
        });

    }

    selectAbeille(abeille, role) {
        setCurrentAbeille(abeille);
        if (role === 'Gérant') {
            setCurrentRole('Gérant');
        } else {
            setCurrentRole('Aidant');
        }
        this.router.navigate(['/profile']);
    }

    checkAbeille(id) {
        let index = this.checkedAbeilles.indexOf(id);

        if (index > -1) {
            this.checkedAbeilles.splice(index, 1);
        } else {
            this.checkedAbeilles.push(id);
        }
    }

    doAction() {
        if (this.actionSelect.nativeElement.value === 'edit') {
            if (this.checkedAbeilles.length > 1) {
                alert('Vous ne pouvez pas éditer plus d\'une abeille à la fois');
                return;
            } else {
                this.sortedAbeilles.forEach(abeille => {
                    if (abeille.data.id === this.checkedAbeilles[0]) {
                        this.currentAbeille = abeille.data;
                    }
                })
                this.showModalEditPatient = true;
            }
        } else if (this.actionSelect.nativeElement.value === 'archive') {
            this.archiveAbeilles(true);
        }
    }

    archiveAbeilles(archive: boolean) {

        const promises = [];

        this.checkedAbeilles.forEach((abeilleId) => {
            promises.push(this.patientService.archive(abeilleId, archive).toPromise());
        });

        Promise.all(promises).then((results) => {
            this.refreshList();
        });
    }

    choiceAbeille(choice) {
        this.showModalPatientChoice = false;

        if (choice === 'Gérant') {
            this.showModalPatient = true;
        }
        if (choice === 'Aidant') {
            this.showModalAidant = true;
        }
    }

    showAbeille(abeille) {
        this.currentAbeille = abeille as Patient;
        this.showModalShowPatient = true;
    }

    sortData(sort: Sort) {
        const data = this.abeilles.slice();
        if (!sort.active || sort.direction === '') {
            this.sortedAbeilles = data;
            return;
        }

        this.sortedAbeilles = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name': return compare(a.name, b.name, isAsc);
                case 'calories': return compare(a.calories, b.calories, isAsc);
                case 'fat': return compare(a.fat, b.fat, isAsc);
                case 'carbs': return compare(a.carbs, b.carbs, isAsc);
                case 'protein': return compare(a.protein, b.protein, isAsc);
                default: return 0;
            }
        });
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
